// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html, body, #root {\n  min-height:100%;\n  height:100%;\n  overflow-x: hidden;\n}\n\n.switch-wrapper {\n  position: absolute;\n  overflow:hidden;\n  height:100%;\n  top:0;   \n  left:0;\n  bottom:0; \n  right:0;\n}\n\n.switch-wrapper > div {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
